import { Form } from 'factorial-form'
import _ from 'lodash'
import { computed, makeObservable } from 'mobx'

import compensations from 'modules/contracts/store/collections/compensations'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import Supplement from 'modules/payroll_bundle/store/models/Supplement'

class SupplementForm extends Form {
  constructor(values: Record<string, any>) {
    super(
      {
        unit: Supplement.units.money,
        ...values,
      },
      {
        id: 'string',
        effective_on: 'date',
        employee_id: 'string',
        variable_compensation_id: 'string',
        amount_in_cents: 'cents',
        percentage_up_to: 'number',
        unit: 'string',
        name: 'string',
        variable_compensation_amount_in_cents: 'cents',
        variable_compensation_recurrence: 'string',
        created_by_access_id: 'string',
        contracts_taxonomy_id: 'string',
        contracts_compensation_id: 'string',
        description: 'string',
        payroll_policy_period_id: 'string',
        imported_on: 'date',
        created_at: 'string',
        source_type: 'string',
        source_id: 'string',
        supplement_bulk_import_id: 'string',
        raw_minutes_in_cents: 'number',
        equivalent_minutes_in_cents: 'number',
        minutes_in_cents: 'number',
      }
    )
    makeObservable(this, {
      hasVariable: computed,
      isMoney: computed,
      isValid: computed,
      employee: computed,
    })
  }

  get hasVariable(): boolean {
    return !!this.get('variable_compensation_id').value
  }

  get isMoney(): boolean {
    return this.get('unit').value === Supplement.units.money
  }

  get isValid(): boolean {
    return !!this.get('amount_in_cents').value && !!this.get('unit').value
  }

  get employee(): Employee | undefined {
    return employees.get(this.get('employee_id').value)
  }

  get supplementData(): Record<string, any> {
    const data = this.data()

    const attrs = _.pick(data, [
      'unit',
      'name',
      'period_id',
      'amount_in_cents',
      'variable_compensation_id',
      'payroll_policy_period_id',
      'supplement_bulk_import_id',
    ])

    if (!data.id) return attrs

    return { ...attrs, id: data.id }
  }

  get compensationType(): string {
    const compensationId = this.data().contracts_compensation_id

    return compensations.get(compensationId)?.attributes.compensation_type ?? ''
  }

  get compensation() {
    return compensations.get(this.data().contracts_compensation_id)
  }

  get compensationRecurrenceCount(): number {
    const compensationId = this.data().contracts_compensation_id
    return compensations.get(compensationId)?.attributes.recurrence_count ?? 1
  }

  get contractTaxonomyId(): string {
    return this.data().contracts_taxonomy_id
  }

  get createdByAccessId(): string {
    return this.data().created_by_access_id
  }
}

export default SupplementForm
